import { render, staticRenderFns } from "./NumberOfInjuriesByRank.vue?vue&type=template&id=73cfff99&scoped=true&"
import script from "./NumberOfInjuriesByRank.vue?vue&type=script&lang=js&"
export * from "./NumberOfInjuriesByRank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cfff99",
  null
  
)

export default component.exports